// Report Builder client. CRUD over /api/reports; the `definition` is an opaque
// JSON document (default data source + params + ordered blocks) the panel owns.
// Block queries run client-side via the query-session API (lib/querysession.js),
// not here — the backend only persists definitions.
import { api } from './api.js';

export const listReports = () => api.get('/api/reports').then((r) => r.reports || []);
export const getReport = (id) => api.get(`/api/reports/${id}`);
export const createReport = (body) => api.post('/api/reports', body);
export const updateReport = (id, body) => api.patch(`/api/reports/${id}`, body);
export const deleteReport = (id) => api.delete(`/api/reports/${id}`);

// A short unique-ish id for blocks/params (client-only; not persisted as a key).
export const rid = (() => {
  let n = 0;
  return (prefix = 'b') => `${prefix}${++n}_${Math.floor(performance.now())}`;
})();
